import { Action } from '@ngrx/store';

export class AdvancedPlatformsActions implements Action {

    public static getPlatforms: string = '[PLATFORMS] GET_PLATFORMS';
    public static getPlatformsError: string = '[PLATFORMS] GET_PLATFORMS_ERROR';
    public static getPlatformsSuccess: string = '[PLATFORMS] GET_PLATFORMS_SUCCESS';

    public static getSubscribes: string = '[PLATFORMS] GET_SUBSCRIBES';
    public static getSubscribesError: string = '[PLATFORMS] GET_SUBSCRIBES_ERROR';
    public static getSubscribesSuccess: string = '[PLATFORMS] GET_SUBSCRIBES_SUCCESS';

    constructor(
        public type: string,
        public payload?: any,
    ) { }

}
